var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremiumbadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Premiumbadge_svg__filter0_d_5736_26091)",
    clipPath: "url(#Premiumbadge_svg__clip0_5736_26091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.529 8.154c-6.83-.892-12.968-2.438-16.9-8.094C16.699 5.716 10.56 7.26 3.73 8.154l-.525.068V23.97c0 14.51 17.425 21.876 17.425 21.876S38.054 38.48 38.054 23.97V8.221l-.525-.067z",
    fill: "url(#Premiumbadge_svg__paint0_linear_5736_26091)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#Premiumbadge_svg__filter1_d_5736_26091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.63 43.434c-1.428-.704-4.434-2.33-7.391-4.83-5.206-4.398-7.847-9.322-7.847-14.631v-13.84C10.7 9.36 16.386 7.973 20.63 3.515c4.243 4.456 9.93 5.846 15.237 6.618V23.97c0 11.165-11.91 17.821-15.236 19.461l-.001.002z",
    fill: "#03070A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.63 42.454c-1.553-.792-4.203-2.301-6.827-4.518-5-4.224-7.535-8.922-7.535-13.963V10.886c4.84-.756 10.185-2.148 14.362-6.133 4.177 3.985 9.522 5.377 14.362 6.133V23.97c0 4.513-2.054 8.777-6.103 12.671-3.09 2.973-6.573 4.947-8.26 5.81v.002z",
    stroke: "url(#Premiumbadge_svg__paint1_linear_5736_26091)",
    strokeWidth: 0.147,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.63 33.439l.767 1.982 2.123.118-1.647 1.343.544 2.056-1.787-1.154-1.786 1.154.544-2.056-1.649-1.343 2.123-.118.768-1.982z",
    fill: "url(#Premiumbadge_svg__paint2_linear_5736_26091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.91 32.035l.385.995 1.065.059-.828.674.275 1.032-.897-.578-.898.578.273-1.032-.828-.674 1.066-.06.387-.994z",
    fill: "url(#Premiumbadge_svg__paint3_linear_5736_26091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.35 32.035l.386.995 1.066.059-.828.674.273 1.032-.897-.578-.896.578.273-1.032-.828-.674 1.066-.06.385-.994z",
    fill: "url(#Premiumbadge_svg__paint4_linear_5736_26091)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Premiumbadge_svg__paint0_linear_5736_26091",
    x1: 20.63,
    y1: 45.848,
    x2: 20.63,
    y2: 0.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CA7D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BE770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#BA7500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AB6E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A26A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CA9F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#EBC94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F8DA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FAE682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FDF9BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F7EFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E5D384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DEC874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F3E9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF9BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Premiumbadge_svg__paint1_linear_5736_26091",
    x1: 20.63,
    y1: 42.538,
    x2: 20.63,
    y2: 4.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB874E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#CA7D26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BE770A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#BA7500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#AB6E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A26A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CA9F2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#EBC94D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F8DA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FAE682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FDF9BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F7EFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E5D384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DEC874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F3E9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF9BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Premiumbadge_svg__paint2_linear_5736_26091",
    x1: 20.63,
    y1: 38.938,
    x2: 20.63,
    y2: 33.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#DBB748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C29938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B3862E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#AE802B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B5882F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5C34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F8DA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FAE682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FDF9BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F7EFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E5D384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DEC874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F3E9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF9BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Premiumbadge_svg__paint3_linear_5736_26091",
    x1: 26.91,
    y1: 34.795,
    x2: 26.91,
    y2: 32.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#DBB748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C29938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B3862E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#AE802B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B5882F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5C34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F8DA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FAE682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FDF9BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F7EFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E5D384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DEC874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F3E9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF9BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Premiumbadge_svg__paint4_linear_5736_26091",
    x1: 14.35,
    y1: 34.795,
    x2: 14.35,
    y2: 32.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8DA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#DBB748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#C29938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#B3862E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#AE802B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B5882F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#E5C34E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F8DA5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FAE682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FDF9BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F7EFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E5D384"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#DEC874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#F3E9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF9BD"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Premiumbadge_svg__filter0_d_5736_26091",
    x: 2.74,
    y: -0.405,
    width: 37.949,
    height: 48.886,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.085,
    dy: 1.085
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.775
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5736_26091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5736_26091",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Premiumbadge_svg__filter1_d_5736_26091",
    x: 4.959,
    y: 3.083,
    width: 31.629,
    height: 41.072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.144,
    dy: 0.144
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.288
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.635294 0 0 0 0 0.415686 0 0 0 0 0 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5736_26091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5736_26091",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Premiumbadge_svg__clip0_5736_26091"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v48.354H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/Premiumbadge.10c2a128.svg";
export { SvgPremiumbadge as ReactComponent };